import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ItnFundedShippingComment = ({ itnFundedShippingComment, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="itnFundedShippingComment" className="planField">
            <GroupApprovers />
            <TextField
                name="itnFundedShippingComment"
                label={xplanLabels.itnFundedShippingComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("itnFundedShippingComment")}
                value={itnFundedShippingComment ? itnFundedShippingComment : ""}
                onChange={(e) => handleChange("itnFundedShippingComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"itnFundedShippingComment"} />}
        </div>
    );
};

export default ItnFundedShippingComment;
